import { render, staticRenderFns } from "./DSTV.vue?vue&type=template&id=ae081bb6&scoped=true&"
import script from "./DSTV.vue?vue&type=script&lang=js&"
export * from "./DSTV.vue?vue&type=script&lang=js&"
import style0 from "./DSTV.vue?vue&type=style&index=0&id=ae081bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae081bb6",
  null
  
)

export default component.exports